<template>
  <div style="font-family: -apple-system-font,PingFang SC,Helvetica Neue,Helvetica,STHeiTi,sans-serif;"
    ref="homeWrapRef">
    <el-carousel height='4rem' style="padding-top:  64px;" :interval="5000">
      <el-carousel-item v-for="(v, i) in bannerSourceList" :key="i">
        <el-image v-if="v.type === 'img'" :src="v.url" style="height: 4rem;width: 100%;">
          <div slot="error" />
        </el-image>
        <video v-else-if="v.type === 'video'" id="" autoplay muted loop preload="auto"
          style="z-index: 200; height: 4rem">
          <source type="video/mp4" :src="v.url" />
        </video>
      </el-carousel-item>
    </el-carousel>

    <!--    平台增效-->
    <div>
      <div style="font-size: 28px;color: #000;text-align: center;margin: 60px 0;">平台增效</div>
      <div class="box">
        <div class="area" style="border-right: 1px rgb(204,204,204) solid;">
          <div class="number">
            <countTo :startVal="0" :endVal="count.effCount" :duration="2000"></countTo>
          </div>
          <div class="text">增效收益(万元)</div>
        </div>
        <div class="area" style="border-right: 1px rgb(204,204,204) solid;">
          <div class="number">
            <countTo :startVal="0" :endVal="count.deviceCount" :duration="2000"></countTo>
          </div>
          <div class="text">接入设备(台)</div>
        </div>
        <div class="area" style="border-right: 1px rgb(204,204,204) solid;">
          <div class="number">
            <countTo :startVal="0" :endVal="count.enterpriseCount" :duration="2000"></countTo>
          </div>
          <div class="text">服务企业(家)</div>
        </div>
        <div class="area">
          <div class="number">
            <countTo :startVal="0" :endVal="count.developerCount" :duration="2000"></countTo>
          </div>
          <div class="text">开发者(名)</div>
        </div>
      </div>
    </div>

    <div style="width: 100%; padding-bottom: 50px;background: #f7f9fc;display: flex; justify-content: center;">
      <div style="width: 75%;height: 100%;">
        <el-row>
          <el-col :span="24">
            <div style="font-size: 28px;color: #000;text-align: center;padding-top: 40px">产品服务</div>
          </el-col>
          <el-col :span="24">
            <div style="font-size: 10px; color: #5a5e66;text-align: center;cursor: pointer;margin: 20px 0;"
              @click="handleMoreDetails('/ProductService', 1)">查看更多 →</div>
          </el-col>
        </el-row>

        <el-row type="flex" justify="space-between" :getter="10">
          <el-col v-for="(item, index) in productList" :key="index" style="text-align: center;cursor: pointer"
            class="tabItem">
            <div @click="changeTypeActive(index)">
              <el-image :scroll-container="homeWrap" lazy
                :src="item.dictCode === 'environmentalSanitation' ? item.dictCode === 'environmentalSanitation' ? require('../assets/images/icon_pro_01.png') : require('../assets/images/icon_pro_02.png') : require('../assets/images/icon_pro_03.png')">
                <div slot="error" />
              </el-image>
              <div style="font-size: 14px;font-weight: 400;color: #e50009;">{{ item.dictLabel }}</div>
              <div v-show="typeActive == index" style="display: flex; ">
                <div style="border-bottom: 4px solid red;padding-top: 10px;width: 60%;"></div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="background: #f7f9fc">
          <el-col :sm="12" :md="6" v-if="productList.length">
            <div
              v-for="(item, index) in productList[typeActive].serviceList.length > 3 ? productList[typeActive].serviceList.slice(0, 2) : productList[typeActive].serviceList.slice(0, 1)"
              :key="item.id" class="star-label" @click="handelProductDetails(item)">
              <div class="label-title">{{ item.productTitle }}</div>
              <div class="label-desc">{{ item.productIntroduction }}</div>
              <div style="display: flex;margin-top: 20px">
                <div style="background: #e50009;color: #fff" class="laber-btn" @click="handelProductDetails(item)">
                  产品详情
                </div>
                <div class="laber-btn" @click="handelConsultClick(item)">
                  立即咨询
                </div>
              </div>
            </div>
          </el-col>
          <el-col :sm="24" :md="18">
            <el-row v-if="productList.length">
              <el-col :xs="12" :sm="12" :md="8"
                v-for="(item, index) in productList[typeActive].serviceList.length > 3 ? productList[typeActive].serviceList.slice(2) : productList[typeActive].serviceList.slice(1)"
                :key="item.id">
                <div class="general-label" @click="handelProductDetails(item)">
                  <div class="label-title">{{ item.productTitle }}</div>
                  <div class="label-desc" style="width: 90%">{{ item.productIntroduction }}</div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 解决方案 -->
    <div style="width: 100%; padding-bottom: 50px; background-color: #000;display: flex; justify-content: center;">
      <div style="width: 75%;height: 100%;max-width: 75%; ">
        <el-row>
          <el-col :span="24">
            <div style="font-size: 28px;color: #fff;text-align: center;padding-top: 40px">解决方案</div>
          </el-col>
          <el-col :span="24">
            <div style="font-size: 10px; color: #f2f2f2;text-align: center;cursor: pointer;margin: 20px 0;"
              @click="handleMoreDetails('/Solution', 2)">查看更多 →</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="display: flex;flex-wrap: wrap;">
          <el-col :xs="24" :md="12" style="margin-bottom: 20px;" v-for="(item, index) in solutionList" :key="item.id">
            <div style="position: relative;display: flex; justify-content: center;align-items: center;"
              class="solution">
              <div class="solution-mask"></div>
              <el-image :scroll-container="homeWrap" lazy fit="fill" :src="item.schemeCover" v-if="item.schemeCover">
                <div slot="error" />
              </el-image>
              <div class="solution-card" @click="toSolution(item)">
                <el-row :gutter="20">
                  <el-col :span="4">
                    <el-image :scroll-container="homeWrap" lazy :src="index < 4 ? solutionIcon[index] : solutionIcon[1]"
                      style="width: 100%; ">
                      <div slot="error" />
                    </el-image>
                  </el-col>
                  <el-col :span="20">
                    <div style="color: #fff;font-size: 0.2rem;font-weight: 600;margin-bottom: 5px;">{{
                      item.solutionTitle
                    }}
                    </div>
                    <div style="color: #fff;font-size: 0.14rem;font-weight: 600;opacity: 0.7;margin-bottom: 5px;">{{
                      item.schemeIntroduction
                    }}</div>
                    <el-button v-if="$store.state.app.device == 'desktop'" size="mini"
                      style="font-size: 14px;opacity: 0.7;margin-top: 10px;">查看方案</el-button>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 案例精选 -->
    <div style="width: 100%; background-color: #F5F5F5;display: flex; justify-content: center;padding-bottom: 40px">
      <div style="max-width: 75%; width: 75%">
        <div style="font-size: 28px;text-align: center;padding: 40px 0">案例精选</div>
        <el-row :gutter="40" style="display: flex;justify-content: center;flex-wrap: wrap;">
          <el-col v-for="(item, index) in caseList" :key="index" :sm="12" :md="6" style="margin-bottom: 20px">
            <el-card :body-style="{ padding: '0px' }" class="evenflow_scale">
              <div @click="handleCaseDetails(item)">
                <el-image :scroll-container="homeWrap" lazy :src="item.caseCover" style="width: 100%;height: 200px">
                  <div slot="error" />
                </el-image>
                <div style="padding: 14px;height: 180px;">
                  <div class="hidden-1" style="font-size: 20px;font-weight: 600;line-height: 60px;">{{
                    item.caseTitle
                  }}
                  </div>
                  <div class="hidden-4" style="font-size: 16px;line-height: 30px;">{{ item.caseContent }}</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 实施项目 -->
    <div style="width: 100%;display: flex; justify-content: center;padding-bottom: 40px">
      <div style="max-width: 75%;width: 75%; text-align:center">
        <div style="font-size: 28px;text-align: center;padding: 40px 0">实施项目</div>
        <MapView />
      </div>
    </div>

    <!-- 服务客户 -->
    <div style="width: 100%;background-color: #F5F5F5;display: flex; justify-content: center;padding-bottom: 40px">
      <div style="max-width: 75%;width: 75%">
        <div style="font-size: 28px;text-align: center;padding: 40px 0">服务客户</div>
        <el-row :gutter="20" style="display: flex;;flex-wrap: wrap;">
          <el-col v-for="(item, index) in customerList" :key="item.id" :xs="12" :sm="8" :md="6"
            style="margin-bottom: 20px;text-align:center">
            <el-image :scroll-container="homeWrap" lazy class="customer-logo" :src="item.unitLogo">
              <div slot="error" />
            </el-image>
          </el-col>
        </el-row>
      </div>
    </div>

    <consult v-if="open" title="立即咨询" :dialogVisible="open" @cancel="cancle" :productName="name" productId="0">
    </consult>
  </div>
</template>

<script>
import count  from "@/api/home.js"
import {downTicket} from "@/api/home.js"
import countTo from "vue-count-to"
import { listProductAll, listSolution, listCase, listClient, listBanner } from '@/api'
import MapView from './mapView/MapView.vue'

export default {
  name: "Home",
  components: {
    countTo,
    MapView
  },
  data () {
    return {
      bannerSourceList: [],
      video: '',
      open: false,
      name: undefined,
      typeActive: 0, //环卫
      count: {},
      productList: [],
      solutionList: [],
      solutionIcon: [
        require('../assets/images/icon_zfzhhwtg.png'),
        require('../assets/images/icon_jtqyscgk.png'),
        require('../assets/images/icon_zhyq.png'),
        require('../assets/images/icon_ccljqsmzqgl.png')
      ],
      caseList: [
        { title: '富阳餐厨垃圾处置智能工厂', name: 'CaseZjnxhjjDetail', desc: '国家十三五规划项目,浙江省的重点示范项目,由杭州滨和集团投资建设,天人环境为主体工艺EPC总承包商...', url: require('../assets/images/img_anli_fuyang.png') },
        { title: '旺能智能管控系统', name: 'CaseDetail', desc: '利用物联网关将PLC等控制系统数据统一采集，通过4G网络上传至云端服务器，实现设备远程监控...', url: require('../assets/images/p1.png') },
        { title: '赤峰智能收运系统', name: 'CaseCfznsyDetail', desc: '提供车辆定位导航，利用大数据模型算法技术实现路径优化、智能调度，从而大大提升了收运效率...', url: require('../assets/images/p2.png') },
        { title: '茅台酒糟智能管控系统', name: 'CaseZjnznhDetail', desc: '通过分布式智慧控制系统的构建，依托整体平台的定位，将数据直观、动态、智慧、交互的展示和运行...', url: require('../assets/images/p4.png') },
      ],
      customerList: [],
      homeWrap: null
    }
  },
  created() {
    if (this.$route.query.ticket && this.$route.query.redirectUrl) {
      downTicket(this.$route.query.ticket).then((res) => {
        if (res.data !== null) {
          localStorage.setItem("usertoken", res.data.token);
          // localStorage.setItem("userName", res.data.userInfo.loginName);
          localStorage.setItem("userName", res.data.userInfo.userName);
          localStorage.setItem("userId", res.data.userInfo.userId);
        }
        window.location.href = this.$route.query.redirectUrl
      })
    }
  },
  mounted () {
    this.homeWrap = this.$refs.homeWrapRef
    // 获取banner数据
    this.getBanner()
    this.getCount()
    // 获取产品服务数据
    this.productData()
    // 获取解决方案数据
    this.solutionData()
    // 获取 案例数据
    this.caseData()
    // 获取 客户数据
    setTimeout(() => {
      this.clientData()
    }, 1000)
  },
  methods: {
    async getBanner () {
      const res = await listBanner({ bannerPosition: 'SY_BANNER' })
      res.rows.forEach(v => {
        if (v.sourceType === 'img') {
          this.bannerSourceList.push({ url: v.bannerImg, type: v.sourceType })
        } else if (v.sourceType === 'video') {
          this.bannerSourceList.push({ url: v.video, type: v.sourceType })
        }
      })
    },
    // 获取客户数据
    async clientData () {
      const res = await listClient({ homepageDisplay: '1', useFlag: '1' })
      this.customerList = res.rows
    },
    // 获取案例数据
    async caseData () {
      const res = await listCase({ homepageDisplay: '1', useFlag: '1' })
      this.caseList = res.rows
    },
    // 获取解决方案数据
    async solutionData () {
      const res = await listSolution({ homepageDisplay: '1', useFlag: '1' })
      // 数据提取
      this.solutionList = res.rows
    },
    // 获取产品服务数据
    async productData () {
      const res = await listProductAll({ homepageDisplay: '1', useFlag: '1' })
      this.productList = res.data
    },
    //解决方案跳转
    toSolution (item) {
      this.$router.push({ path: '/SolutionDetails', query: { id: item.id } })
    },
    //产品服务-产品详情按钮跳转详情页
    handelProductDetails (item) {
      this.$router.push({ path: '/ProductDetails', query: { id: item.id } })
    },
    // 改变通用产品分类选中
    changeTypeActive (val) {
      this.typeActive = val
    },
    // 获取平台增效数值
    getCount () {
      count.getAllCount().then(res => {
        if (res.code === 0) {
          this.count = res.data;
        } else {
          this.count = {
            deviceCount: 700,
            enterpriseCount: 170,
            developerCount: 360,
            effCount: 491.41
          }
        }
      })
    },
    go () {
      this.$router.push({ path: '/DaliIndex' })
    },
    //查看更多
    handleMoreDetails (path, index) {
      this.$router.push({ path: path, query: { index: index } })
    },
    handleCaseDetails (item) {
      this.$router.push({
        path: "/solition_lower",
        query: {
          id: item.id
        }
      })
    },
    handelConsultClick (item) {
      this.name = item.productTitle
      this.open = true
    },
    cancle (data) {
      this.open = data
    }
  }
}
</script>

<style lang="scss" scoped>
.star-label {
  min-height: 130px;
  background: #fff;
  margin: 30px 0;
  padding: 20px;
  cursor: pointer;
  transition: .5s all;

  &:hover {
    box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.25);
  }

  &:hover .label-title {
    color: #e50009;
  }

  .laber-btn {
    width: 118px;
    height: 28px;
    line-height: 28px;
    margin-right: 10px;
    text-align: center;
    font-size: 14px;
    color: #e50009;
    border: 1px solid #e50009;
  }
}

.label-title {
  font-size: 16px;
  font-weight: 600;
  color: #131415;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.label-desc {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: rgba(19, 20, 21, 0.70);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: 40px;
}


.general-label {
  min-height: 75px;
  margin: 30px 0;
  cursor: pointer;
  transition: .5s all;

  &:hover .label-title {
    color: #e50009;
  }
}

.solution {
  height: 2.61rem;
  /* height: 261px; */

  .solution-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #252525;
    opacity: 0.9;
    transition: .5s all;
    z-index: 1;
  }

  .el-image {
    width: 100%;
    height: 100%;
  }

  .solution-card {
    position: absolute;
    width: 80%;
    cursor: pointer;
    z-index: 99;

  }

  &:hover .solution-mask {
    opacity: 0.3;
    border-bottom: 3px solid #e50009;
  }
}

.customer-logo {
  transition: all 0.5s;
  width: 1.84rem;
  height: .9rem;
  max-width: 100%
}

.customer-logo:hover {
  transform: scale(1.2);
}

.title {
  font-size: 0.32rem;
  padding: 0.6rem 0;
  text-align: center;
}

.box {
  padding: 0 2.0rem;
  height: 1.92rem;

  .area {
    width: calc(25% - 1px);
    text-align: center;
    float: left;

    .number {
      span {
        font-size: 0.48rem;
        color: #e50009;
      }
    }

    .text {
      color: #19191a;
    }

    .image {
      height: 0.6rem;

      img {
        margin-bottom: -0.05rem;
        margin-right: 0.15rem;
        width: 0.48rem;
      }

      span {
        color: #1a1a1a !important;
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue